import { decorate, observable } from 'mobx';
import { ParentStore } from '@mq/voltron-parent';

class BeneficiariesStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.load(args);
  }
}

decorate(BeneficiariesStore, {
  token: observable,
  alias: observable,
  account_number: observable,
  sort_code: observable,
  routing_number: observable,
  currency: observable,
  status: observable,
  user_token: observable,
  created_time: observable,
  last_modified_time: observable,
  loading: observable,
});

export default BeneficiariesStore;
